import { parseBoolean } from "@signolteam/shared/utils";
import { operatorEndpoints } from "@src/services/endpoints";
import { queryClient } from "@src/utils/queryClient";
import {
  USER_COOKIE,
  STALE_TIME_1HS,
  SAML_SSO_COOKIE,
} from "@src/constants/constants";
import StorageUtils from "@src/utils/storageUtils";

const operatorLoader = async () => {
  const currentUser = await StorageUtils.getObjectItemWithRetry(
    USER_COOKIE,
  ).catch((err) => {
    console.error("Failed to retrieve user:", err);
    return null; // treat errors as null
  });

  if (!currentUser?.roles?.includes("CAPTAIN")) {
    console.warn("unauthorized");
    return null;
  }

  const isSSO = parseBoolean(StorageUtils.getItem(SAML_SSO_COOKIE));
  if (isSSO) {
    const externalId = currentUser.metadata?.external_id;
    if (externalId?.length) {
      try {
        //For first-time SSO logins, this will create the Operator + AppUser in the DB
        await operatorEndpoints.operatorProfileLink({
          identifier: externalId,
          firstname: currentUser.firstname,
          lastname: currentUser.lastname,
        });
      } catch (error) {
        //Squash any error, the app will work fine for already registered+linked users
        console.error(
          `Failed to link operator profile for externalId=${externalId}:`,
          error,
        );
      }
    }
  }

  return queryClient.ensureQueryData({
    queryKey: ["OPERATOR_PROFILE", currentUser],
    staleTime: STALE_TIME_1HS,
    queryFn: () => operatorEndpoints.getOperatorProfile(currentUser),
  });
};

export default operatorLoader;
